import React from 'react';
import './policy.css';

function policy() {

    return (
        <div>
            <div id='policy-header'></div>
            <div id='policy-main'>
                <div id='policy-left'></div>
                    <div id='policy-center'>
                <div className='link-class'><a href='https://twitter.com/audreywrightNYC'>Twitter</a></div>
                <div className='link-class'><a href='https://bsky.app/profile/audreywrightxxx.bsky.social'>Bluesky</a></div>
                <div className='link-class'><a href='https://onlyfans.com/audreywrightxxx'>Onlyfans</a></div>
                <div className='link-class'><a href='https://fansly.com/AudreywrightXXX/posts'>Fansly</a></div>

                <div className='link-class'><a href='https://www.theeroticreview.com/reviews/audrey-2018753471-351716'>TER Reviews</a></div>

                        </div>
                <div id='policy-right'></div>
            </div>
        </div>)
}
export default policy;

